module.exports = __webpack_public_path__ + "img/twitter-icon.615fad60.svg";